<template>
  <a-row :gutter="16">
    <a-col :span="14">
      <a-input
        v-decorator="[
          'captcha',
          { rules: [{ required: true, message: '请输入图形验证码' }] }
        ]"
        size="large"
        placeholder="图形验证码"
      />
    </a-col>
    <a-col :span="10">
      <img width="80px" height="40px" src="@/assets/logo.png" alt="" />
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'VerificationCode'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus"></style>
